import { useMemo } from "react";

type PaginationProps = {
  pages?: number;
  current?: number;
  limit?: number;
  pageurl?: string;
};
export default function Pagination({
  pages = 10,
  current = 1,
  limit = 5,
  pageurl,
}: PaginationProps) {
  const arrOfPages = useMemo(() => {
    const halfLimit = Math.floor(limit / 2);
    const items = Array.from(
      { length: limit },
      (_, i) => current - halfLimit + i,
    );
    while (items[0] < 1) {
      const n = items.shift() || 0;
      items.push(n + limit);
    }
    while (items[items.length - 1] > pages) {
      const n = items.pop() || 0;
      if (items[0] > 1) items.unshift(n - limit);
    }
    if (items[0] !== 1) {
      items[0] = 1;
      items[1] = 0;
    }
    if (items[items.length - 1] !== pages) {
      items[items.length - 1] = pages;
      items[items.length - 2] = 0;
    }
    return items;
  }, [pages, current, limit]);

  return (
    <nav className="pagination">
      <ul>
        <li>
          <a
            aria-disabled={current <= 1}
            href={`${pageurl}${pageurl.includes("?") ? "&" : "?"}page=${current - 1}`}
            aria-label="Forrige side"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0303 6.03033C11.3232 5.73744 11.3232 5.26256 11.0303 4.96967C10.7374 4.67678 10.2626 4.67678 9.96966 4.96967L3.46967 11.4697C3.32714 11.6122 3.25397 11.7978 3.25016 11.9846C3.24995 11.9949 3.24995 12.0051 3.25016 12.0154C3.25208 12.1107 3.27176 12.2016 3.30604 12.285C3.34265 12.3742 3.39719 12.4578 3.46967 12.5303L9.96966 19.0303C10.2626 19.3232 10.7374 19.3232 11.0303 19.0303C11.3232 18.7374 11.3232 18.2626 11.0303 17.9697L5.81066 12.75L20.5 12.75C20.9142 12.75 21.25 12.4142 21.25 12C21.25 11.5858 20.9142 11.25 20.5 11.25L5.81066 11.25L11.0303 6.03033Z"
                fill="#262626"
              />
            </svg>
          </a>
        </li>

        {arrOfPages.map((page, idx) => {
          return (
            <li key={idx}>
              {page ? (
                <a
                  aria-current={page === current ? "page" : undefined}
                  className={page === current ? "active" : undefined}
                  href={`${pageurl}${pageurl.includes("?") ? "&" : "?"}page=${page}`}
                >
                  {page}
                </a>
              ) : (
                <span>&hellip;</span>
              )}
            </li>
          );
        })}

        <li>
          <a
            aria-disabled={current >= pages}
            href={`${pageurl}${pageurl.includes("?") ? "&" : "?"}page=${current + 1}`}
            aria-label="Neste side"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0303 4.96967C13.7374 4.67678 13.2626 4.67678 12.9697 4.96967C12.6768 5.26256 12.6768 5.73744 12.9697 6.03033L18.1893 11.25L3.5 11.25C3.08579 11.25 2.75 11.5858 2.75 12C2.75 12.4142 3.08579 12.75 3.5 12.75L18.1893 12.75L12.9697 17.9697C12.6768 18.2626 12.6768 18.7374 12.9697 19.0303C13.2626 19.3232 13.7374 19.3232 14.0303 19.0303L20.5303 12.5303C20.6622 12.3985 20.7399 12.2226 20.7491 12.0372M20.5463 11.4861C20.541 11.4805 20.5357 11.4751 20.5303 11.4697L14.0303 4.96967"
                fill="currentColor"
              />
            </svg>
          </a>
        </li>
      </ul>
    </nav>
  );
}
